import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import de from './locales/de.json';
import hi from './locales/hi.json';
import te from './locales/te.json';
import ta from './locales/ta.json';
import ml from './locales/ml.json';
import kn from './locales/kn.json';
import zh from './locales/zh.json';

import { detectLocaleFromIp } from './ipGeoDetector';

export const SUPPORTED_LOCALES = ['en', 'hi', 'te', 'ta', 'ml', 'kn', 'de', 'fr', 'es', 'zh'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      es: { translation: es },
      de: { translation: de },
      hi: { translation: hi },
      te: { translation: te },
      ta: { translation: ta },
      ml: { translation: ml },
      kn: { translation: kn },
      zh: { translation: zh },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LOCALES,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'sublingox_ui_lang',
    },
  })
  .then(() => {
    document.documentElement.lang = i18n.language;
  });

// Keep the <html lang> attribute in sync so screen readers and browser
// translation tools treat the page as the language actually being rendered.
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

// If no saved preference: try device locale first, then IP geo as fallback
if (!localStorage.getItem('sublingox_ui_lang')) {
  const deviceLang = (navigator.languages || [navigator.language])
    .map((l) => l.split('-')[0].toLowerCase())
    .find((l) => SUPPORTED_LOCALES.includes(l));

  if (deviceLang) {
    i18n.changeLanguage(deviceLang);
  } else {
    detectLocaleFromIp().then((lang) => {
      if (lang) i18n.changeLanguage(lang);
    });
  }
}

export default i18n;
